import UAParser from 'ua-parser-js';
// from https://github.com/g13n/ua.js/blob/master/src/ua.js
function detect(pattern) {
    return function () {
        var userAgent = navigator.userAgent || '';
        return pattern.test(userAgent);
    };
}
var UA = {
    isWeixin: detect(/micromessenger/i),
    isWeibo: detect(/weibo/i),
    isXiaomi: detect(/xiaomi/i),
    isBaidu: detect(/baiduboxapp|baidubrowser/i),
    isIOS: function () {
        var _a;
        return ((_a = new UAParser().getOS().name) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === 'ios';
    },
    isAndroid: function () {
        var _a;
        return ((_a = new UAParser().getOS().name) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === 'android';
    },
    isMobile: detect(/(iphone|ipod|((?:android)?.*?mobile)|blackberry|nokia)/i),
    isFrodo: detect(/com\.douban\.frodo/i),
    isFrodoMovie: detect(/com\.douban\.(doubanmovie|movie)/i),
    isWeapp: detect(/miniprogram/i),
    isPre: detect(/(com\.douban\.frodo\/[\d.]+[.\w]*(dev|debug|test))|(com\.douban\.frodo\.test)/i),
    getParser: function () {
        return new UAParser();
    },
};
export default UA;
//# sourceMappingURL=ua.js.map